import { render, staticRenderFns } from "./SidebarBrandSwitcher.vue?vue&type=template&id=a315679e&scoped=true&"
import script from "./SidebarBrandSwitcher.vue?vue&type=script&lang=ts&"
export * from "./SidebarBrandSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarBrandSwitcher.vue?vue&type=style&index=0&id=a315679e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a315679e",
  null
  
)

export default component.exports